module.exports = __webpack_public_path__ + "img/product_bg_2.1c57ae80.jpg";